// Anbudsoppdrag: har anbudsfrist og ingen fastpris. Fastpris-oppdrag utløper aldri.
export function isBidOrder(order) {
  return !!order && order.bidDeadline != null && order.fixedPrice == null;
}

// Anbudsfristen er passert (kun for anbudsoppdrag).
export function isBidExpired(order, now = new Date()) {
  if (!isBidOrder(order)) return false;
  const d = order.bidDeadline?.toDate?.();
  return !!d && d < now;
}

const MONTHS_SHORT_NB = ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sept.', 'okt.', 'nov.', 'des.'];

export function monthShortNb(date) {
  return MONTHS_SHORT_NB[date.getMonth()];
}
